const Chats = ({ who ,chat}) => {
  let chatClass = who === "self" ? "flex-end  " : "flex-start  ";
  

  return (
    <>
      <div className='chattingDiv  ' style={{ alignSelf: chatClass }}>
        <div className={who==="self"? 'rightchat': "leftchat"} > {chat.message}  </div>
        <div className='timeStampChat' style={who==="self"? {alignItems:"flex-end"}: {alignItems:"flex-start"}}>
          <p>{chat.time}</p>
          {who === "self" && chat.seen && <p>seen</p>}
        </div>
      </div>
    </>
  );
};

export default Chats;
